import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ProgressLoaderService {
    isLoading = new BehaviorSubject<boolean>(false);

    showProgress() {
        this.isLoading.next(true);
    }

    hideProgress() {
        this.isLoading.next(false);
    }
}